import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { DonHangMuaService } from '../don-hang-mua-page-service/don-hang-mua.service';
import { HistoryLogBodyDto } from '../don-hang-mua-page-model/don-hang-mua.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';

@Component({
	selector: 'm-history-log',
	templateUrl: './history-log.component.html',
	styleUrls: ['./history-log.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class ThuMuaHistoryLogComponent implements OnInit {
	// Config Form
	CONFIG: CommonConFig;
	isChange: boolean = false;
	saveAddedTTHV: number[] = [];
	viewLoading = false;
	historiesData: HistoryLogBodyDto[] = [];
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	//#endregion Khai báo biến

	//#region Constructor
	constructor(
		private _service: DonHangMuaService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		private router: Router,
		private changeDetect: ChangeDetectorRef,
		public dialogRef: MatDialogRef<ThuMuaHistoryLogComponent>,
		private layoutUtilsService: LayoutUtilsService) {
		this.dialogRef.disableClose = true;
	}
	//#endregion Constructor

	//#region Load Data
	ngOnInit() {
		this.CONFIG = new CommonConFig();
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
		});
    this.changeDetect.detectChanges();
    
		this._service.fetchHistoriesChange(this.data.purchaseOrderId).subscribe({
			next: (res: any) => {
				if (res && res.status === 1) {
					const result = res.data ? res.data : [];
					this.historiesData = result.slice();
					this.changeDetect.detectChanges();
				} else {
					const errorMessage = res.error.message || 'Có lỗi xảy ra khi tải lịch sử thay đổi';
					this.layoutUtilsService.showErorr(errorMessage);
				}
			},
			error: (err) => {
				this.layoutUtilsService.showErorr('Không thể tải dữ liệu lịch sử thay đổi');
			}
		});
    
	}

	ngAfterViewInit() {
		this.changeDetect.detectChanges();
	}

	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}

	checkDashboardRoute() {
		if (this.router.url === '/')
			return true;
		return false;
	}

	back() {
		this.dialogRef.close({
			isChange: this.isChange,
			dataAdd: this.saveAddedTTHV
		});
	}

	f_number(item: any = "0.00000") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
	}

  getFormatDate(v: string = "") {
		if (v != "") {
			return v.includes("T")
				? v.replace(
						/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g,
						"$5/$3/$1"
				  )
				: v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return "";
	}
}
